import React from "react";
import { Chip } from "@mui/material";
import {
  PASTEL_CHIP_BASE_SX,
  runStatusChipSx,
} from "features/integrationsBeta/platformEnumUi";

type Props = {
  status: string | null;
  label: string;
  size?: "small" | "medium";
};

export default function RunStatusChip({
  status,
  label,
  size = "small",
}: Props) {
  if (!status) {
    return <span aria-label="No status">—</span>;
  }
  return (
    <Chip
      label={label}
      size={size}
      sx={{
        ...PASTEL_CHIP_BASE_SX,
        minWidth: 100,
        ...(runStatusChipSx(status) as object),
      }}
    />
  );
}
